import { createContext, useRef, useState, useEffect } from 'react'

export const PortalContext = createContext<HTMLElement>(null)

export const usePortalState = () => {
  const portalRef = useRef()

  const [portal, setPortal] = useState()

  useEffect(() => {
    setPortal(portalRef.current)
  }, [])

  return [portal, portalRef] as const
}
